export default class SampleCategoryWriteDTO {

    public id: number;
    public name: string;
    public defaultWeight: number | null;
    public tariffCode: string | null;
    public sampleTypeId: number;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.name = data['name'];
        this.defaultWeight = data['defaultWeight'] || null;
        this.tariffCode = data['tariffCode'] || null;
        this.sampleTypeId = data['sampleTypeId'];
    }
}